import React from 'react'
import { Pause } from 'lucide-react'
import { ActivityState } from '@/redux/slices/timerConfigurationSlice'
import CountdownTimer from '@/components/OGE/CountDownTimer'
import { useAppSelector } from '@/redux/hooks'
import { RootState } from '@/redux/store'
import { defaultTimerAlerts } from './types'

interface TimerDisplayProps {
  manualMode?: boolean
  roundStatus: ActivityState | null
  isInfinitePhase: boolean
  endTime?: string | null
  phaseStatus?: ActivityState | null
  showWarning?: boolean
}

export const TimerDisplay: React.FC<TimerDisplayProps> = ({
  manualMode = false,
  roundStatus,
  isInfinitePhase,
  endTime,
  phaseStatus,
  showWarning = true,
}) => {
  const alertsFromStore = useAppSelector(
    (state: RootState) => state.timerConfiguration.config?.alerts
  )
  const alerts = { ...defaultTimerAlerts, ...alertsFromStore }

  if (manualMode && roundStatus !== ActivityState.Paused) {
    return <span className='text-gray-500'>--:--</span>
  }

  if (roundStatus === ActivityState.Paused) {
    return (
      <span className='text-amber-500 text-sm flex items-center gap-1'>
        <Pause className='size-4' />
        Paused
      </span>
    )
  }

  if (isInfinitePhase) {
    return <span className='text-gray-500'>∞</span>
  }

  if (endTime && phaseStatus) {
    return (
      <CountdownTimer
        endTime={endTime}
        showWarning={showWarning}
        status={phaseStatus}
        enableFiveMinuteVisual={alerts.enableFiveMinuteVisual}
        enableOneMinuteVisual={alerts.enableOneMinuteVisual}
      />
    )
  }

  return null
}
